<template>
	<div class="operationPersonerManage mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">直营商电费管理</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">运营商列表</span>
				</div>
				<!-- <div class="icon_add iconBox" @click="itemClick({},5)" title="新增运维人员"></div> -->
			</div>
			<div class="BtnBox disBetween">
				<div class="searchBox disBetween">
					<div class="disBetween searchLeft">
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.serviceProviderName" placeholder="请输入直营商名称">
							</el-input>
						</div>
						<div class="myinputBox myinputBox5">
							<el-date-picker  v-model="searchObj.startTime" value-format="yyyy-MM-dd" type="date"
								placeholder="开始时间">
							</el-date-picker>
						</div>
						<div class="myinputBox myinputBox5">
							<el-date-picker v-model="searchObj.endTime" value-format="yyyy-MM-dd" type="date"
								placeholder="结束时间">
							</el-date-picker>	
							<!-- <el-date-picker v-model="searchObj.searchData" type="daterange" range-separator="~"
								value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker> -->
						</div>
						<el-button type="success" @click="toSearch">查询</el-button>
					</div>
					<el-button type="success" @click="exportData">导出</el-button>
				</div>
			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" stripe style="width: 100%">
							<el-table-column type="index" label="序号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="serviceProviderName" label="直营商">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="startTime" label="结算开始时间">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="endTime" label="结算结束时间">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="elecConsumption" label="电量(kWh)">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="elecUnitPrice" label="单价电费(元)">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="electricCharge" label="运营电费(元)">
							</el-table-column>
							<el-table-column label="操作" width="150">
								<template slot-scope="scope">
									<el-button  type="text" size="small"
										@click="itemClick(scope.row,2)">编辑</el-button>
									<el-button  type="text" size="small"
										@click="itemClick(scope.row,1)">查看</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination  mypagination">
						<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
							:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
							layout="total, prev, pager, next,jumper" ref="pagination"
							@current-change="handleCurrentChange">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="电费" center class="mydialog" :visible.sync="dialogVisible" width="50%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm4" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox dialogBox4">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="结算周期">
								<div class="myinputBox">
									{{creatObj.startTime}}~{{creatObj.endTime}}
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="计费方式" prop="billingMode">
								<div class="myinputBox">
									<el-radio-group v-model="creatObj.billingMode" @change="changeRadio" :disabled="creatObj.disabled==1">
										<el-radio label="1">单价计算</el-radio>
										<el-radio label="2">总价计算</el-radio>
									</el-radio-group>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween" v-if="creatObj.billingMode==1">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="用电量" prop="elecConsumption">
								<div class="myinputBox">
									<el-input type="number" clearable v-model="creatObj.elecConsumption"
										placeholder="请输入用电量" @change="changeElecConsumption" :disabled="creatObj.disabled==1">
										<template slot="append">kWh</template>
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="电费单价" prop="elecUnitPrice">
								<div class="myinputBox">
									<el-input clearable type="number" v-model="creatObj.elecUnitPrice"
										placeholder="请输入电费单价" @change="changeElecUnitPrice" :disabled="creatObj.disabled==1">
										<template slot="append">元/kWh</template>
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween" v-if="creatObj.billingMode">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="电费" prop="electricCharge">
								<div class="myinputBox">
									<el-input type="number" :disabled="creatObj.billingMode==1 || creatObj.disabled==1" clearable
										v-model="creatObj.electricCharge" placeholder="请输入电费">
										<template slot="append">元</template>
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter" v-if="creatObj.disabled==1">
					<el-button type="primary" @click="dialogVisible=false">确 定</el-button>
				</el-form-item>
				<el-form-item class="diabtnBox disCenter" v-else>
					<el-button @click="dialogVisible=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm4')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import {
		timestampToDate
	} from "../../../assets/js/common.js"
	export default {
		name: "operationPersonerManage",
		components: {},
		data() {
			let that = this;
			return {
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				creatObj: {
					disabled:"",
					billId: "", //对账记录id
					serviceProviderName: "", //运营商名称
					startTime: "", //结算开始时间
					endTime: "", //结算结束时间
					billingMode: "", //1单价计费 2总价计费
					elecConsumption: "", //用电量
					elecUnitPrice: "", //单价电费
					electricCharge: "" //电费
				},
				dialogVisible: false,
				NOfalse: false,
				statusList: [{
						text: "通过",
						value: 2
					},
					{
						text: "不通过",
						value: 3
					}
				],
				tableData: [],
				loading: false,
				searchObj: {
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
					serviceProviderName: "",
					startTime: "",
					endTime: "",
					searchData: [],
				},
				rules: {
					billingMode: [{
						required: true,
						message: '请选择计费方式',
						trigger: 'change'
					}],
					elecConsumption: [{
						required: true,
						message: '请输入用电量',
						trigger: 'blur'
					}],
					elecUnitPrice: [{
						required: true,
						message: '请输入电费单价',
						trigger: 'blur'
					}],
					electricCharge: [{
						required: true,
						message: '请输入电费',
						trigger: 'blur'
					}],
				},
			}
		},
		mounted() {
			// let time = new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000
			// this.searchObj.searchData = [timestampToDate(time), timestampToDate(new Date().getTime())]
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			changeRadio(e){
				console.log(e)
				this.$set(this.creatObj,"electricCharge","")
				this.$set(this.creatObj,"elecUnitPrice","")
				this.$set(this.creatObj,"elecConsumption","")
			},
			changeElecConsumption(e){
				console.log(e)
				if(e){
					this.$set(this.creatObj,"electricCharge",e*this.creatObj.elecUnitPrice)
				}
			},
			changeElecUnitPrice(e){
				console.log(e)
				if(e){
					this.$set(this.creatObj,"electricCharge",e*this.creatObj.elecConsumption)
				}
			},
			exportData(){
				let timeObj={
					startTime:"",
					endTime:"",
				}
				if (this.searchObj.searchData && this.searchObj.searchData.length > 0) {
					timeObj.startTime = this.searchObj.searchData[0]
					timeObj.endTime = this.searchObj.searchData[1]
				}else {
					timeObj.startTime = ''
					timeObj.endTime = ''
				}
				let obj={
					serviceProviderName:this.searchObj.serviceProviderName,
					startTime: timeObj.startTime, //开始时间
					endTime: timeObj.endTime, //结束时间
				}
				this.$api.exportDirectServiceProviderBill(obj,"运营商电费管理列表").then((res)=>{
					if(res.returnCode==200){
						
					}
				})
			},
			// 保存按钮点击事件 新建/编辑
			toSave(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let obj = {
							billId: that.creatObj.billId,
							billingMode: that.creatObj.billingMode,
							elecConsumption:that.creatObj.billingMode==1?that.creatObj.elecConsumption:"",
							elecUnitPrice: that.creatObj.billingMode==1?that.creatObj.elecUnitPrice:"",
							electricCharge: that.creatObj.electricCharge,
						}
						console.log(obj)
						that.$api.updateDirectServiceProviderBill(obj).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '编辑成功!'
								});
								setTimeout(() => {
									that.getData()
								}, 500)
								this.dialogVisible = false
							}
						})

					} else {
						return false;
					}
				});

			},
			itemClick(item, n) {
				let that = this
				this.$set(this, "creatObj", item)
				this.$set(this.creatObj, "disabled", n)
				this.$set(this.creatObj, "billingMode", item.billingMode+"")
				console.log(this.creatObj)
				this.dialogVisible = true
				this.$nextTick(() => {
					if (that.$refs.ruleForm1) {
						that.$refs.ruleForm1.clearValidate()
					}
				})
			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				return obj.text
			},
			toSearch() {
				this.$set(this.PageInfo,"pagenum",1)
				this.$set(this.searchObj,"pageNo",1)
				this.getData()
			},
			getData(n) {
				this.loading = true
				this.$api.listDirectServiceProviderBill(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "tableData", res.obj.list)
						this.$set(this.PageInfo, "total", res.obj.total || 0)
						this.loading = false
					}
				})
			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo,"pagenum",val)
				this.$set(this.searchObj,"pageNo",val)
				this.getData({})
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./businessPowerManange.scss";
</style>